<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Clientes IKAcesso</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>												
					</template>
				</Toolbar>

				<DataTable :value="clientes"   :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>	
					<Column field="id" header="Id" sortable></Column>			
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="razaoSocial" header="Razao Social" sortable></Column>
					<Column field="cnpj" header="CNPJ" sortable></Column>
					<Column field="cpf" header="CPF" sortable></Column>	
					<Column field="dataCadastro" header="Cadastro" sortable>
						<template #body="slotProps">
							{{ formatarData(slotProps.data.dataCadastro )}}
						</template>
					</Column>					
					<Column field="ativo" header="Ativo" sortable>
						<template #body="slotProps">
							<label v-if="slotProps.data.ativo">Sim</label>
							<label v-else>Não</label>
						</template>
					</Column>					
					<Column v-if="permissaoEditar">						
						<template #body="slotProps">
							<SplitButton label="Ações" class="p-button-secondary" :model="acoes(slotProps.data)" appendTo="body" ></SplitButton>						
						</template>						
					</Column>
				</DataTable>						

			</div>
		</div>
	</div>
</template>

<script>

import ClienteIKAcessoService from '@/service/ClienteIKAcessoService.js';
import { exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
	clienteService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,			
            clientes: [],
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),	
		novo() {
			this.$router.push('/cadastro/clientes/ikacesso/novo');
		},
		editar(cliente) {
			this.$router.push('/cadastro/clientes/ikacesso/'+cliente.id+'/editar');
		},	
		listar() {
			this.clienteService.listarTodos()
            .then(resp => {		
				this.clientes = resp.data.entity;
            }).catch(erro => {              
                if(erro.response && erro.response.data.status == 401) {
                    exibirMensagemSis(this, erro.response.data.message, true);					
                } else {
                    exibirMensagemSis(this, 'Erro interno do servidor', true);
                    console.log(erro.request)
                } 
            }); 
		},	
		acoes(cliente) {
			let acoes =[
				{label: 'Editar', icon: 'pi pi-pencil', idCliente:cliente.id, command: (event) => {									
						this.$router.push('/cadastro/clientes/ikacesso/'+event.item.idCliente+'/editar');
					}
				},
				{label: 'Licenças', icon: 'pi pi-id-card', idCliente:cliente.id, command: (event) => {
						this.clientes.forEach(cliente => {
							if(cliente.id == event.item.idCliente) {							
								sessionStorage.setItem('CLIENTE_LICENCAS', JSON.stringify(cliente));
							}
						});	
						this.$router.push('/cadastro/clientes/ikacesso/licencas/'+event.item.idCliente);
					}
				},
			];
			return acoes;
		},
		formatarData(strDate, comHora) {
            let data = '';
            if(!comHora) {
                let partes = strDate.split('-');
                data = partes[2]+'/'+partes[1]+'/'+partes[0];
            } else {
				let arrData = strDate.split(' ');
				let partes = arrData[0].split('-');
                data = partes[2]+'/'+partes[1]+'/'+partes[0]+' '+arrData[1];
            }
            return data;
        },
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(99999);
			this.permissaoEditar = permissoes.includes(99999);				
		}
	},	
	created() {
		this.clienteService = new ClienteIKAcessoService();
		this.listar();
	},
	mounted() {	
		this.validarPermissoes();			
	}
}
</script>

<style scoped>
</style>